import React, { useEffect, useState } from "react";
import { Button, LogoLoader, SmartTooltip, TableAdv } from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { fetchSimilarSubmissions } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { usePagination } from "../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { Link } from "react-router-dom";

const SimilarSubmission = ({ jobPostId }) => {
  const dispatch = useDispatch();
  const [submissionRows, setSubmissionRows] = useState([]);
  const { value } = useSelector((state) => state.totalCount);
  const [selectedRows, setSelectedRows] = useState([]);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );
  const totalCount = value?.similarSubmissionCount?.data || 0;
  const [loading, setLoading] = useState(true);
  const [totalCount2, setTotalCount2] = useState(0);

  const colSubmission = [
    {
      key: "sNo",
      label: "S.No",
    },
    {
      key: "name",
      label: "Name",
      render: (row) => (
              <SmartTooltip
                description={formatWords2(row.name)}
                size="xs"
                color="black"
                noicon
                tooltipPosition="bottom"
                portal={true}
              >
                <Link
                  to={`/ats/applicants/applicant-details`}
                  state={{ applicantId: row?.id, source: "/ats/jobs/job-details?job-details=talent-match", selectedJobUiid:jobPostId  }}
                  className="text-info-400 flex items-center gap-.5"
                >
                  <span className="mx-2 line-clamp-1">
                    {formatWords2(row.name)}
                  </span>
                </Link>
              </SmartTooltip>
            ),
    },
    {
      key: "email",
      label: "Email ID",
    },
    {
      key: "phone",
      label: "Phone number",
    },
    {
      key: "jobTitle",
      label: "Job Title",
    },
    {
      key: "experience",
      label: "Experience (In years)",
    },
    {
      key: "workAuthorization",
      label: "Work Authorization",
    },
    {
      key: "location",
      label: "Location",
    },
  ];
  const fetchSubmissions = async () => {
    // if (!submissions?.length) return;

    try {
      setLoading(true);
      const res = await fetchSimilarSubmissions({
        coll: "JobPosting",
        pg: page,
        lim: limit,
        fil: { uiid: { type: "AG_JOBPOST_SIMILAR_SUBMISSIONS", value: "", jobPostId: jobPostId } },//jobPostId 
        useAggregate: true
      });

      const data = res?.data?.data || [];
      const getAllSubmissions = (data) => {
        if (!data) return [];
        // case: array of containers [{matchingSubmissions: [...]}, ...]
        if (Array.isArray(data) && data.length && data[0]?.matchingSubmissions !== undefined) {
          return data.flatMap(d => d.matchingSubmissions || []);
        }
        // case: single container object { matchingSubmissions: [...] }
        if (data.matchingSubmissions) return data.matchingSubmissions;
        // case: already the submissions array
        if (Array.isArray(data)) return data;
        return [];
      };

      const submissions = getAllSubmissions(data);

      const formattedRows = submissions.map((item, index) => {
        const candidate = item.candidateId || {};
        const job = item.submissionJob || item.submissionJobPost || {};
        const location = candidate.location || {};

        // normalize email: candidate.email may be string or object { primary: "..." }
        const email =
          typeof candidate.email === "string"
            ? candidate.email
            : candidate.email?.primary?.email ?? candidate.email?.primary ?? "";

        // normalize phone
        const phone = candidate.mobile?.primary
          ? `${candidate.mobile.primary.code || ""} ${candidate.mobile.primary.number || ""}`.trim()
          : "";

        // experience formatting
        const experience = candidate.exp
          ? `${candidate.exp.year || 0}y ${candidate.exp.mon || 0}m`
          : "";

        // location formatting: prefer "City, State"
        const locParts = [];
        if (location.city) locParts.push(location.city);
        if (location.state?.name) locParts.push(location.state.name);
        const locationStr = locParts.length ? locParts.join(", ") : (location.country?.name);

        // work authorization — try a few likely places and fallback to N/A
        const workAuthorization =
          formatWords2(candidate.workAuth) ||
          "";
        return {
          id: candidate.uiid,
          sNo: index + 1,
          // Candidate Info
          name: `${candidate.firstName || ""} ${candidate.lastName || ""}`.trim(),
          email,
          phone,
          jobTitle: formatWords2(candidate.jobTitle || job.title),
          experience,
          workAuthorization,
          location: locationStr,
          // optional: preserve raw fields if you need them later
          _raw: { item, candidate, job }
        };
      });
      setSubmissionRows(mapTableRows(formattedRows, colSubmission));
      setTotalCount2(res?.data?.data?.[0]?.totalCount || 0);
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "jobpostings",
        coll: "JobPosting",
        tname: "similarSubmissionCount",
        filters: { uiid: { type: "AG_JOBPOST_SIMILAR_SUBMISSIONS", value: "", jobPostId: jobPostId } },
        app: "ats",
      })
    );
    fetchSubmissions();
  }, [jobPostId, dispatch, limit, page]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LogoLoader />
      </div>
    );
  }

  const handleSelectionChange = (selectedRow) => {
    setSelectedRows(selectedRow);
  };

  return (
    <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex-1 overflow-hidden shadow-tableset">
          <TableAdv
            tableId={"jobs_jobdetails_similarsubmission_table"}
            showCheckbox
            columns={colSubmission}
            // rows={mappedRowSubmission}
            rows={submissionRows}
            serverPagination={true}
            totalCount={totalCount2}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            defaultSelectedRows={selectedRows}
            onSelectionChange={handleSelectionChange}
            onLimitChange={handleLimitChange}
            tdClassName="!py-3"
            toolbarRight={{
              search: true,
              fullScreen: true,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-2">
                      <Button title="Bulk Mail" size="sm" />
                    </div>
                  ),
                },
              ],
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default SimilarSubmission;
